import React, { Component } from 'react';
import { Button, Col, Input, Row, Modal, Form, ModalBody, Card, Collapse } from 'reactstrap';
import { StyledCard, FormatAmountNumber, BlankCard } from '../../Base/Common/CommonUIComponents';
import { getStatus, getRightVoucherId } from '../../Base/Common/ReferenceDataFunctions';
import OperatorDataSection from '../../Base/Common/OperatorDataSection';
import { handleNotification } from '../../Base/Common/Notification';
import { CustomTable } from '../../Base/Common/CustomTable';
import { FormattedMessage, injectIntl } from 'react-intl';
import { getAPI, postAPI } from '../../Base/API';
import moment from 'moment';
import BlockUi from 'react-block-ui';
import { ErrorAlert } from '../../Base/ErrorAlert';
import ProfileInfoSection from '../../Base/Common/ProfileInfoSection';

export class ExpiredWithoutInvoice extends Component {
    static displayName = ExpiredWithoutInvoice.name;

    _isMounted = false;
    constructor(props) {
        super(props);
        
        this.state = {
            block: true,
            voucherList: [],
            pageIndex: 1,
            pageSize: 10
        }
    }


    componentDidMount() {
        this.getVouchers()
    }

    getVouchers = (e) => {
        if (e) e.preventDefault();

        this.setState({ block: true }, _ => {
            let params = '?pageIndex=' + (this.state.pageIndex - 1) + '&pageSize=' + this.state.pageSize;

            if (this.state.minDaysExpired) {
                params += '&minDaysExpired=' + this.state.minDaysExpired;
            }

            getAPI(result => {
                const { data, error } = result;
                const errorMessage = [];

                if (error) {
                    errorMessage.push({ message: error.message, stack: error.stack, messageType: 'danger' });
                    this.setState({ error: errorMessage, block: false });

                    return;
                }
                if (data) {
                    if (data.errors && data.errors.length > 0) {
                        handleNotification(data);
                    }
                    if (data) {
                        this.setState({ 
                            error: errorMessage, 
                            block: false, voucherList: 
                            data.response, 
                            totalItems: data.count
                        });
                    }
                    else {
                        this.setState({ voucherList: [], block: false });
                    }
                }
                else this.setState({ error: errorMessage, block: false });
            }, '/api/Voucher/Voucher/v1/expiredvouchers' + params);
        });                
    }

    handleTableChange = (type, { page, sizePerPage }) => {
        this.setState({
            pageIndex: (page),
            pageSize: sizePerPage
        }, () => { this.getVouchers(null, true) });
    }
    
    toggleModal() {
        this.setState(prevState => ({
            modal: !prevState.modal
        }));
    }


    doSearch = (e) => {
        if(e) e.preventDefault();

        this.setState({ 
            pageIndex: 1, 
            selectedVouchers: [] 
        }, () => this.getVouchers(null, true));
    }

    toggleInvoiceModal = () => {
        this.setState(
            prevState => ({ invoiceModal: !prevState.invoiceModal }),
            () => {
                if (!this.state.invoiceModal) {
                    this.doSearch();
                }
            }
        );
    }


    render() {
        const columns = [
            {
                dataField: 'voucherId',
                text: this.props.intl.formatMessage({ id: "OperationManagement.CardId" }),
                sort: true,
                formatter: (cell, row) => getRightVoucherId(cell, row.voucherIdFirst8)
            },
            {
                dataField: 'hotelName',
                text: this.props.intl.formatMessage({ id: "VoucherOperationDetails.SoldAt" }),
                sort: true
            },
            {
                dataField: 'saleOrigin',
                text: this.props.intl.formatMessage({ id: "OperationManagement.Channel" }),
                sort: true
            },
            {
                dataField: 'ordinal',
                text: this.props.intl.formatMessage({ id: "OperationManagement.Number" }),
                sort: true
            },
            {
                dataField: 'voucherTypeCode',
                text: this.props.intl.formatMessage({ id: "OperationManagement.CardType" }),
                sort: true
            },
            {
                dataField: 'salePrice',
                text: this.props.intl.formatMessage({ id: "generic.salePrice" }),
                sort: true,
                formatter: (cell) => <FormatAmountNumber value={cell} />
            },
            {
                dataField: 'createdAt',
                text: this.props.intl.formatMessage({ id: "OperationManagement.IssueDate" }),
                sort: true,
                formatter: (cell) => cell ? moment(cell).format("YYYY-MM-DD") : null
            },
            {
                dataField: 'status',
                text: this.props.intl.formatMessage({ id: "OperationManagement.Status" }),
                sort: true,
                formatter: (cell) => {
                    if (cell) {
                        const status = getStatus(true).find(s => s.value === cell);
                        return status ? status.label : ''
                    }
                }
            },
            {
                dataField: 'validUntil',
                text: this.props.intl.formatMessage({ id: "OperationManagement.ValidUntil" }),
                sort: true
            }
        ];
        
        const selectRow = {
            mode: 'checkbox',
            clickToSelect: true,
            bgColor: '#f5f9ff',
            selected: (this.state.selectedVouchers || []).map(v => v.voucherId),
            onSelect: (row, isSelect) => {
                const selectedVouchers = [...(this.state.selectedVouchers || [])];
                if (isSelect) {
                    if (!selectedVouchers.some(v => v.voucherId === row.voucherId)) {
                        selectedVouchers.push(row);
                    }
                } else {
                    const idx = selectedVouchers.findIndex(v => v.voucherId === row.voucherId);
                    if (idx > -1) selectedVouchers.splice(idx, 1);
                }
                this.setState({ selectedVouchers });
            },
            onSelectAll: (isSelect, rows) => {
                if (isSelect) {
                    this.setState({ selectedVouchers: rows });
                } else {
                    this.setState({ selectedVouchers: [] });
                }
            }
        };


        return (
            <StyledCard icon={'fa-solid fa-gift'} title={'navbar.ExpiredWithoutInvoice'} id="expiredWithoutInvoice" error={this.state.error} block={this.state.block}>
                <Form onSubmit={this.doSearch}>
                    <Row className="mb-3 align-items-center">
                        <Col sm={2}>
                            <Input
                                type="number"
                                min="0"
                                max='90'
                                name="minDaysExpired"
                                value={this.state.minDaysExpired ?? ''}
                                onChange={(e) => this.setState({ minDaysExpired: e.target.value })}
                                placeholder={this.props.intl.formatMessage({ id: "ExpiredWithoutInvoice.MinDaysSinceExpiration" })}
                            />
                        </Col>
                        <Col className="text-right">
                            <Button className="btn-host btn-sm mr-2" onClick={this.toggleInvoiceModal} disabled={!this.state.selectedVouchers || this.state.selectedVouchers.length === 0} title={this.props.intl.formatMessage({ id: "ExpiredWithoutInvoice.IssueInvoices" })}>
                                <i className="fa-solid fa-file-invoice-dollar" />
                            </Button>
                            <Button className="btn-host btn-sm" type="submit">
                                <i className="fa-solid fa-magnifying-glass " />
                            </Button>
                        </Col>
                    </Row>
                </Form>

                <CustomTable
                    keyField="voucherId"
                    data={this.state.voucherList ? this.state.voucherList : []}
                    columns={columns}
                    shadow={false}
                    totalSize={this.state.totalItems}
                    onTableChange={this.handleTableChange}
                    search={false}
                    showTotal={true}
                    remote={true}
                    hideSizePerPage={false}
                    page={parseInt(this.state.pageIndex || 1)}
                    sizePerPage={this.state.pageSize}
                    selectRow={selectRow}
                />

                {this.state.invoiceModal && (
                    <Modal isOpen={this.state.invoiceModal} toggle={this.toggleInvoiceModal} size="xl">
                        <ModalBody>
                            <IssueVoucherInvoices
                                selectedVouchers={this.state.selectedVouchers}
                                onClose={this.toggleInvoiceModal}
                            />
                        </ModalBody>
                    </Modal>
                )}
            </StyledCard>
        );
    }
}

export default injectIntl(ExpiredWithoutInvoice);

const IssueVoucherInvoices = ({ selectedVouchers = [] }) => {
    const [hostUserCode, setHostUserCode] = React.useState('');
    const [hostUserPassword, setHostUserPassword] = React.useState('');
    const [hostUserCashboxCode, setHostUserCashboxCode] = React.useState('');
    const [hostPaymentCodes, setHostPaymentCodes] = React.useState([{ hostPaymentCode: null, amount: 0 }]);
    const [block, setBlock] = React.useState(false);
    const [errors, setErrors] = React.useState([]);
    const [vouchersInvoiceProgress, setVouchersInvoiceProgress] = React.useState(selectedVouchers);
    const [isOperatorDataOpen, setIsOperatorDataOpen] = React.useState(true);
    const [isProfileInfoOpen, setIsProfileInfoOpen] = React.useState(true);
    const [customerData, setCustomerData] = React.useState({});

    const issueInvoices = async () => {
        if (!vouchersInvoiceProgress || vouchersInvoiceProgress.length === 0) return;

        setBlock(true);

        const request = {
            hostUserCode: hostUserCode,
            hostUserPassword: hostUserPassword,
            hostUserCashboxCode: hostUserCashboxCode,
            HostPaymentCodes: hostPaymentCodes
        };

        // Adiciona os dados do cliente ao request
        Object.assign(request, customerData);


        for (const voucher of vouchersInvoiceProgress) {
            if (voucher.invoiceStatus && voucher.invoiceStatus !== 'error') {
                continue;
            }

            const voucherId = voucher.voucherId;      

            // Set voucher to loading status
            setVouchersInvoiceProgress(prev => prev.map(v => v.voucherId === voucherId ? { ...v, invoiceStatus: 'loading' } : v));
            
            request.voucherId = voucher.id;

            await new Promise(resolve => {
                postAPI(result => {
                    const { data, error } = result;
                    if (error) {
                        errors.push({ voucherId, message: error.message });
                        setVouchersInvoiceProgress(prev => prev.map(v => v.voucherId === voucherId ? { ...v, invoiceStatus: 'error' } : v));
                    } 
                    else if (data) {
                        if (data.errors?.length > 0 || data.warnings?.length > 0) {
                            errors.push({ voucherId, message: data.errors.map(e => e.description || e.message).join('; ') });
                            handleNotification(data);
                            setVouchersInvoiceProgress(prev => prev.map(v => v.voucherId === voucherId ? { ...v, invoiceStatus: 'error' } : v));
                        } 
                        else if(data.response?.length > 0) {
                            setVouchersInvoiceProgress(prev =>
                                prev.map(v =>
                                    v.voucherId === voucherId ?
                                        { 
                                            ...v, 
                                            status: data.response[0].status, 
                                            expiredInvoiceURL: data.response[0].expiredInvoiceURL,
                                            expiredInvoiceReference: data.response[0].expiredInvoiceReference,
                                            invoiceStatus: 'success' 
                                        }
                                    : v
                                )
                            );
                        }
                    }
                    resolve();
                }, '/api/Voucher/Voucher/v1/expiredvouchers/invoice', { request });
            });
        }

        setBlock(false);
        setErrors(errors);
    }

    const handlePaymentCodeSelect = (val, evt) => {
        if (evt) {
            const { value } = val;
            
            const paymentCodes = [...hostPaymentCodes];

            paymentCodes[0].hostPaymentCode = value;

            setHostPaymentCodes(paymentCodes);
        }
    }

    const handleSelect = (val, evt) => {
        if (evt) {
            let name = evt.name;
            let value = val.value;

            if (name === 'hostUserCode') {
                setHostUserCode(value);
                setHostUserCashboxCode(null);
            }
            else if (name === 'hostUserCashboxCode') {
                setHostUserCashboxCode(value);
            }
        }
    }

    const handleChange = (evt) => {
        let value = evt.target.value;

        setHostUserPassword(value);
    }

    const handleCustomerDataChange = (field, value) => {
        setCustomerData(prev => ({
            ...prev,
            [field]: value
        }));
    }

    const updateCustomerData = (updatedData) => {
        setCustomerData(prev => ({
            ...prev,
            ...updatedData
        }));
    }

    
    return (
        <div>
            <BlockUi tag="div" blocking={block} >
                <ErrorAlert errors={errors} />
                <Form onSubmit={e => { e.preventDefault(); issueInvoices(); }}>
                    <Row>
                        <Col>
                            <h5><FormattedMessage id="ExpiredWithoutInvoice.IssueInvoices" /></h5>
                        </Col>
                        <Col className="text-right">
                            <Button className="bth-host btn-sm" color="primary" type="submit" disabled={vouchersInvoiceProgress.every(v => v.invoiceStatus === 'success')}>
                                <i className='fa-solid fa-floppy-disk'/>
                            </Button>
                        </Col>
                    </Row>
                                 
                    <Row className="mt-4 pointer" onClick={() => setIsProfileInfoOpen(!isProfileInfoOpen)}>
                        <Col>
                            <h6>
                                <FormattedMessage id="AddVoucher.ClientInfo" />
                            </h6>
                        </Col>
                    </Row>
                    <hr className="mb-3 mt-0" />   
                    <Collapse isOpen={isProfileInfoOpen}>        
                        <ProfileInfoSection
                            voucher={customerData}
                            handleChange={(e) => handleCustomerDataChange(e.target.name, e.target.value)}
                            handleSelect={(e) => handleCustomerDataChange(e.target.name, e.target.value)}
                            updateVoucherData={updateCustomerData}
                            hideTitle={true}
                            fiscalNumberRequired={true}
                        />
                    </Collapse>
        
                    <Row className="mt-4 pointer" onClick={() => setIsOperatorDataOpen(!isOperatorDataOpen)}>
                        <Col>
                            <h6>
                                <FormattedMessage id="AddVoucher.OperatorData" />
                            </h6>
                        </Col>
                        <Col className="text-right col-1">
                            <span>
                                <i className={`fa-solid ${isOperatorDataOpen ? 'fa-chevron-up' : 'fa-chevron-down'}`} />
                            </span>
                        </Col>
                    </Row>

                    <hr className="mb-3 mt-0" />

                    <Collapse isOpen={isOperatorDataOpen}>                    
                        <OperatorDataSection
                            operatorData={{hostUserCode, hostUserCashboxCode, hostUserPassword, HostPaymentCodes: hostPaymentCodes}}
                            handleSelect={handleSelect}
                            handlePaymentCodeSelect={handlePaymentCodeSelect}
                            handleHostUserPass={handleChange}
                            hideTitle={true}
                        />
                    </Collapse>
                </Form>
                
                <Row className="mt-4 pt-2">
                    <Col>
                        <h6><FormattedMessage id="ExpiredWithoutInvoice.ExpiredVouchers" /></h6>
                    </Col>
                </Row>
                
                <hr className="mb-3 mt-0" />

                <Card body className="border-0 shadow mt-2 mb-2 py-2 text-muted">
                    <Row>
                        <Col>
                            <FormattedMessage id="OperationManagement.CardId" />
                        </Col>
                        <Col>
                            <FormattedMessage id="OperationManagement.CardType" />
                        </Col>
                        <Col sm={2}>
                            <FormattedMessage id="OperationManagement.ValidUntil" />
                        </Col>
                        <Col>
                            <FormattedMessage id="OperationManagement.Status" />
                        </Col>
                        <Col>
                            <FormattedMessage id="ExpiredWithoutInvoice.InvoiceStatus" />
                        </Col>
                    </Row>
                </Card>
                
                <Card body className="border-0 shadow py-0">
                    {vouchersInvoiceProgress.map((voucher, idx) => (
                        <Row key={idx} className="py-2 my-1 overbglight border-bottom">
                            <Col className="text-truncate">
                                {getRightVoucherId(voucher.voucherId, voucher.voucherIdFirst8)}
                            </Col>
                            <Col>
                                {voucher.voucherTypeCode}
                            </Col>
                            <Col sm={2}>
                                {voucher.validUntil}
                            </Col>
                            <Col>
                                {voucher.status ? getStatus(true).find(s => s.value === voucher.status)?.label : ''}
                            </Col>
                            <Col>
                                {voucher.invoiceStatus === 'loading' && <span><i className="fa-solid fa-spinner fa-spin" /> Loading...</span>}
                                {voucher.invoiceStatus === 'error' && <span className="text-danger"> Error</span>}
                                {voucher.invoiceStatus === 'success' && (
                                    <span className="text-success">
                                        <FormattedMessage id="generic.success" />
                                        {voucher.expiredInvoiceURL && (
                                            <i 
                                                className="fa-solid fa-sm fa-arrow-up-right-from-square ml-2" 
                                                style={{ cursor: 'pointer' }}
                                                onClick={() => window.open(voucher.expiredInvoiceURL, '_blank')}
                                                title="Open invoice"
                                            />
                                        )}
                                    </span>
                                )}
                                {!voucher.invoiceStatus && <span className='text-muted'> <FormattedMessage id="ExpiredWithoutInvoice.NotInvoiced" /></span>}
                            </Col>
                        </Row>
                    ))}
                </Card>
            </BlockUi>
        </div>
    );  
};